/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { useContext } from 'react';

import { Divider, Grid } from '@coursera/cds-core';

import { panelExpandedWidthPx } from 'bundles/grading/components/layout/LeftPanel';
import { SGAPageContext } from 'bundles/grading/components/staff-graded-assignments/SGAPageContext';
import GradedProgressBar from 'bundles/grading/components/staff-graded-assignments/left-panel/GradedProgressBar';
import GradingFlowTitle from 'bundles/grading/components/staff-graded-assignments/left-panel/GradingFlowTitle';
import SGALazyLoadLeftPanel from 'bundles/grading/components/staff-graded-assignments/left-panel/SGALazyLoadLeftPanel';
import Submitters from 'bundles/grading/components/staff-graded-assignments/left-panel/Submitters';
import FiltersControl from 'bundles/grading/components/staff-graded-assignments/left-panel/search-and-filters/FiltersControl';
import FiltersSummary from 'bundles/grading/components/staff-graded-assignments/left-panel/search-and-filters/FiltersSummary';
import SearchControl from 'bundles/grading/components/staff-graded-assignments/left-panel/search-and-filters/SearchControl';
import { getGradedTotal } from 'bundles/grading/utils/submissionUtils';

const styles = {
  container: () => css`
    display: flex;
    flex-flow: column;
    width: ${panelExpandedWidthPx}px;
    height: 100%;
  `,
  paddedSection: () => css`
    padding: 0 var(--cds-spacing-200);
  `,
  stretchedBody: () => css`
    flex-grow: 1;
    overflow-y: auto;
  `,
  divider: () => css`
    margin-bottom: var(--cds-spacing-200);
  `,
  controls: () => css`
    margin-bottom: var(--cds-spacing-200);
    display: flex;
  `,
  filtersSummary: () => css`
    margin-bottom: var(--cds-spacing-100);
  `,
};

// Container for SGA left panel related components
const SGALeftPanel = () => {
  const { submitterList, assignmentInfo } = useContext(SGAPageContext);

  // TODO: Lazy load needs to match v2 layout
  if (submitterList.loading || assignmentInfo.loading) {
    return <SGALazyLoadLeftPanel />;
  }
  if (submitterList.error || !submitterList.data || assignmentInfo.error || !assignmentInfo.data) {
    return null;
  }

  const { submitters, isTeamAssignment } = submitterList.data;
  const { gradingStatusSummary } = assignmentInfo.data;

  return (
    <Grid container css={styles.container}>
      <div css={styles.paddedSection}>
        <GradingFlowTitle total={submitters.length} isTeamAssignment={isTeamAssignment} />
        <GradedProgressBar
          total={gradingStatusSummary.total}
          graded={getGradedTotal(gradingStatusSummary.statusCounts)}
        />
        <Divider css={styles.divider} />
      </div>

      <div css={[styles.paddedSection, styles.controls]}>
        <SearchControl isTeamAssignment={isTeamAssignment} />
        <FiltersControl />
      </div>
      <div css={[styles.paddedSection, styles.filtersSummary]}>
        <FiltersSummary />
      </div>

      {/*
        not using `styles.paddedSection` here, because `<Submitters />` includes
        pagination control, which should use whole width
        */}
      <div css={styles.stretchedBody}>
        <Submitters />
      </div>
    </Grid>
  );
};

export default SGALeftPanel;
